import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';

import { inChildren } from 'services/utils';
// import DialogTitle from '@material-ui/core/DialogTitle';
import { makeAction } from 'modules/redux-modals';

import * as actions from 'resources/Groups/actions';
import { IconBtnAdd } from 'components/buttons/IconBtn';
import Field from 'components/Field';
import Filter, { FilterSearchField } from 'components/Filter';
import List from 'components/List';

class Container extends Component {
  componentDidMount() {
    this.getList();
  }

  getList = (params) => {
    const { getList } = this.props;
    getList(params);
  };

  render() {
    const { children, ...rest } = this.props;
    return inChildren(children, {
      ...rest,
      getList: this.getList
    });
  }
}

const mapStateToProps = (state) => {
  const { groups = {} } = state;
  const { list = {} } = groups;
  return {
    record: list
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(actions, dispatch)
});

const ContainerConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);

const useStyles = makeStyles((theme) => ({
  modalDividers: {
    padding: 0
  },
  modalContentRoot: {
    padding: theme.spacing(1),
    '&:first-child': {
      paddingTop: theme.spacing(1)
    }
  }
}));

const GroupsList = (props) => {
  const classes = useStyles();
  const {
    // title = "Группы",
    isOpen,
    handleClose = () => null,
    cancelText = 'Закрыть',
    onSelect = () => null
  } = props;

  return (
    <Dialog
      open={isOpen}
      scroll={'paper'}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      fullWidth={true}
      maxWidth="md"
      // onClose={() => handleClose(false)}
    >
      {/* <DialogTitle>{title}</DialogTitle> */}
      <DialogContent
        dividers={true}
        classes={{
          root: classes.modalContentRoot,
          dividers: classes.modalDividers
        }}>
        <ContainerConnect>
          <List
            {...props}
            // Toolbar={false}
            filter={
              <Filter>
                <FilterSearchField source="name" label="Имя группы" alwaysOn />
              </Filter>
            }>
            <Field label="ID" source="id" sortable />
            <Field label="Имя группы" source="name" sortable />
            <Field
              label="Роли"
              source="roles"
              format={(v) => (v ? JSON.parse(v) : [])}>
              {({ value }) => value.map((it) => <Chip key={it} label={it} />)}
            </Field>
            <Field
              label="Кол-во пользователей"
              source="users_count"
              type="number"
              sortable
            />
            <Field source="id" isAction>
              {({ value }) => {
                return (
                  <React.Fragment>
                    <IconBtnAdd onClick={() => onSelect(value)} />
                  </React.Fragment>
                );
              }}
            </Field>
          </List>
        </ContainerConnect>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleClose(false)}
          color="primary"
          variant="contained">
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const show = makeAction(GroupsList);
export default GroupsList;
